import { render, staticRenderFns } from "./BaseInputSelectWithFreightServiceReadOnly.vue?vue&type=template&id=e893e924&scoped=true&"
import script from "./BaseInputSelectWithFreightServiceReadOnly.vue?vue&type=script&lang=js&"
export * from "./BaseInputSelectWithFreightServiceReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e893e924",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VIcon,VSelect})
